var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isShow)?_c('left'):_vm._e(),_c('v-main',[_c('v-container',[_c('router-view')],1)],1),(false)?_c('v-footer',{attrs:{"app":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }